import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { DotProps } from 'react-multi-carousel';

import Image from '@/app/components/Image';
import MultiCarousel from '@/app/components/MultiCarousel';
import { RESPONSIVE_DATA } from '@/app/components/MultiCarousel/constants';

const CarouselDot = ({
  active,
  index,
  onClick,
}: Pick<DotProps, 'active' | 'index' | 'onClick'>) => {
  return (
    <li className="mb-10 lg:my-20">
      <button
        aria-label={`Jump to slide ${index! + 1}`}
        className={cx({ 'bg-gray-300': active })}
        onClick={onClick}
      />
    </li>
  );
};
const responsiveData = {
  ...RESPONSIVE_DATA,
  desktop: { ...RESPONSIVE_DATA['desktop']!, items: 2 },
};

const FitnessTestimonials = () => {
  const t = useTranslations();

  return (
    <div className="relative bg-sandstone-100 py-10 lg:py-20">
      <LayoutGrid>
        <div className="col-main lg:col-start-3">
          <Typography color="inherit" variant="h2" Element="h2">
            {t('testimonials_title')}
          </Typography>
        </div>
      </LayoutGrid>
      <LayoutGrid className="grid-flow-col">
        <div className="col-full col-start-2 md:col-start-3">
          <MultiCarousel
            autoPlay
            autoPlayWhenVisible
            infinite
            containerClass="my-10 lg:my-20 select-none cursor-pointer"
            customDot={
              <CarouselDot active={false} index={0} onClick={() => {}} />
            }
            dotListClass="mb-10 lg:my-20"
            responsive={responsiveData}
            slidesToSlide={1}
            arrows={false}
          >
            <div className="mr-5 flex h-full">
              <div className="mr-5 w-3/5">
                <Image
                  src="/ad/dpdobesh"
                  width={430}
                  height={600}
                  alt="David Dobesh"
                  className="pointer-events-none h-[calc(100%-2rem)]"
                />
                <Typography className="mt-2">@dpdobesh</Typography>
              </div>
              <div className="w-2/5">
                <Image
                  localizedAlt="testimonials_image_alt_lindseyvonn"
                  src="/ad/lindseyvonn"
                  width={600}
                  height={600}
                  className="pointer-events-none"
                />
                <Typography className="my-5">
                  &lsquo;{t('testimonial_lindseyvonn')}&rsquo;
                </Typography>
                <Typography>@lindseyvonn</Typography>
              </div>
            </div>
            <div className="mr-5 flex h-full">
              <div className="w-full">
                <Image
                  src="/ad/kailenny"
                  width={600}
                  height={600}
                  localizedAlt="testimonials_image_alt_kailenny"
                  className="pointer-events-none w-full"
                />
                <Typography className="my-5">
                  &lsquo;{t('testimonial_kailenny')}&rsquo;
                </Typography>
                <Typography>@kailenny</Typography>
              </div>
            </div>
            <div className="mr-5 flex h-full">
              <div className="mt-auto mr-5 w-2/5">
                <Typography className="mb-5">
                  &lsquo;{t('testimonial_chrispaul')}&rsquo;
                </Typography>
                <Image
                  src="/ad/chrispaul"
                  width={600}
                  height={600}
                  localizedAlt="testimonials_image_alt_chrispaul"
                  className="pointer-events-none"
                />
                <Typography className="mt-2">@chrispaul</Typography>
              </div>
              <div className="w-3/5">
                <Image
                  src="/ad/leighrichards"
                  width={600}
                  height={600}
                  alt="Leigh Richards"
                  className="pointer-events-none h-[100%-2rem]"
                />
                <Typography className="mt-2">@leighrichards</Typography>
              </div>
            </div>
            <div className="mr-5 flex h-full">
              <div className="mr-5 w-3/5">
                <Image
                  src="/ad/suvvey"
                  width={600}
                  height={600}
                  localizedAlt="testimonials_image_alt_suvvey"
                  className="pointer-events-none h-[100%-2rem]"
                />
                <Typography className="mt-2">@suvvey</Typography>
              </div>
              <div className={`mt-auto w-2/5`}>
                <Typography className="mb-5">
                  &lsquo;{t('testimonial_carisamoore')}&rsquo;
                </Typography>
                <Image
                  src="/ad/carisamoore"
                  width={600}
                  height={600}
                  localizedAlt="testimonials_image_alt_carisamoore"
                  className="pointer-events-none"
                />
                <Typography className="mt-2">@carisamoore</Typography>
              </div>
            </div>
          </MultiCarousel>
        </div>
      </LayoutGrid>
    </div>
  );
};

export default FitnessTestimonials;
